var map = {
	"./addtoprofilebutton_de.png": 96,
	"./addtoprofilebutton_en.png": 97,
	"./addtoprofilebutton_fr.png": 98,
	"./award_land_der_ideen.jpg": 99,
	"./b2b_award_logo.png": 100,
	"./cc.png": 101,
	"./certificate_sample.jpg": 102,
	"./clear.png": 103,
	"./companies.jpg": 104,
	"./course-cover-default.jpg": 105,
	"./course-page-card_big.png": 106,
	"./course-page-card_image.png": 107,
	"./course-page-card_image_inline.png": 108,
	"./course-page-card_inline.png": 109,
	"./course-page-card_small.png": 110,
	"./course-placeholder.jpg": 111,
	"./course_default.png": 112,
	"./download-easy-guide.jpg": 113,
	"./drag_dark.png": 114,
	"./drag_light.png": 115,
	"./draggable.png": 116,
	"./example_voucher_card_de.jpg": 117,
	"./example_voucher_card_en.jpg": 118,
	"./example_voucher_card_fr.jpg": 119,
	"./fabian.jpg": 120,
	"./female_speaker_bg.jpg": 121,
	"./h5p_docu_1.png": 122,
	"./h5p_docu_2.png": 123,
	"./logo-iversity-without-padding.png": 124,
	"./logo-iversity.png": 125,
	"./logo_highres.png": 126,
	"./logo_iversity_springer.svg": 127,
	"./organisation_purchase.jpg": 128,
	"./petal_cutted.png": 129,
	"./posters_points.png": 130,
	"./professor_bg.jpg": 131,
	"./purchase_voucher_header.jpg": 132,
	"./referrals.jpg": 133,
	"./speech-bubble.svg": 134,
	"./voucher_card.png": 135,
	"./work_with_us.png": 136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;